export const projectStatus = {
  COMPLETE: 'Complete',
  INCOMPLETE: 'Incomplete',
  PARTIAL: 'Partial',
} as const;

export type ProjectStatus = (typeof projectStatus)[keyof typeof projectStatus];

export const reportingEnabled = {
  NOT_AVAILABLE: 'Not Available',
} as const;

export type ReportingEnabled = (typeof reportingEnabled)[keyof typeof reportingEnabled];
